<div class="overlay" (click)="closeModal()">
  <div class="modal" (click)="$event.stopPropagation()">
    <h2>Importar Deck</h2>

    <p>
      Para importar um deck evie um arquivo <strong>.xlsx</strong> onde o nome do arquivo vai ser
      usado como nome do deck, na <strong>coluna A</strong> coloque o que vai ficar na frente do
      cartão e na <strong>coluna B</strong>
      coloque a resposta.
    </p>

    <p>Selecione uma Pasta para armazenar o deck:</p>

    <!-- Atualizado para iterar pelas pastas e usar selectedFolderId -->
    <select name="folder" [(ngModel)]="selectedFolderId">
      <option value="">Selecione uma Pasta</option>
      @for (folder of folders; track folder.idPasta) {
        <option [value]="folder.idPasta">{{ folder.nome }}</option>
      }
    </select>

    <p>Selecione um arquivo para importar:</p>

    @if (!isMobile) {
      <div
        class="drop-zone"
        [class.drag-over]="isDragging"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
        (click)="fileInput.click()"
      >
        <input
          type="file"
          #fileInput
          (change)="onFileSelected($event)"
          accept=".xlsx, .xls"
          hidden
        />

        <div class="drop-message">
          Arraste e solte o arquivo aqui ou
          <span>clique para selecionar</span>
        </div>
      </div>
    } @else {
      <div class="mobile-upload">
        <input
          type="file"
          #fileInput
          (change)="onFileSelected($event)"
          accept=".xlsx, .xls"
          hidden
        />

        <button class="but" (click)="fileInput.click()">Selecionar Arquivo</button>
      </div>
    }

    @if (fileName) {
      <div class="file-info">
        <p><strong>Arquivo:</strong> {{ fileName }}</p>
        <p><strong>Nome do Deck:</strong> {{ deckName }}</p>
        <p><strong>Cartões lidos:</strong> {{ flashcardsParaEnviar.length }}</p>
      </div>
    }

    <button class="but" (click)="importarDeck()">Importar</button>
    <button class="but btn-cancel" (click)="closeModal()">Cancelar</button>
  </div>
</div>
